import React, { useEffect, useState } from 'react';
export function UrgencyBar() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 30,
    seconds: 0
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          ...prev,
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const f = (v: number) => v.toString().padStart(2, '0');
  return <div className="fixed top-0 left-0 w-full z-50 bg-black/95 border-b border-yellow-500/50 py-1.5 px-3" data-id="element-50">
      <div className="max-w-7xl mx-auto flex justify-center items-center gap-3 text-[11px] sm:text-xs font-bold text-white" data-id="element-51">
        <span className="relative flex h-2 w-2" data-id="element-52">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75" data-id="element-53" />
          <span className="relative inline-flex rounded-full h-2 w-2 bg-red-600" data-id="element-54" />
        </span>
        <span className="uppercase tracking-wide" data-id="element-55">
          OFERTA LIMITADA — 47 copias
        </span>
        <span className="text-yellow-500/60" data-id="element-56">|</span>
        <span className="text-yellow-500 font-mono bg-zinc-900 px-1.5 py-0.5 rounded text-[10px] sm:text-[11px] border border-yellow-500/20" data-id="element-57">
          {f(timeLeft.hours)}:{f(timeLeft.minutes)}:{f(timeLeft.seconds)}
        </span>
      </div>
    </div>;
}